// extracted by mini-css-extract-plugin
export default {"hoeToCiteBox":"howToCite_hoeToCiteBox__ivznc","copyBox":"howToCite_copyBox__I6P2B","imgBox":"howToCite_imgBox__nho9M"};